/**
 * Promise holder.
 */
export class Deferred<T> {
  private _promise: Promise<T>;
  // Use definite assignment assertion (!) and type strictly matching Promise constructor's resolve
  private _resolve!: (value: T | PromiseLike<T>) => void;
  // Use definite assignment assertion (!) for reject as well
  private _reject!: (reason?: any) => void;

  constructor() {
    this._promise = new Promise<T>((resolve, reject) => {
      // Assign the actual resolve and reject functions from the Promise constructor
      // Types now match correctly
      this._resolve = resolve;
      this._reject = reject;
    });
  }

  /**
   * Stored promise.
   */
  get promise(): Promise<T> {
    return this._promise;
  }

  /**
   * Resolves the stored promise.
   * The public method still allows the value to be optional for flexibility.
   */
  public resolve = (value?: T | PromiseLike<T>): void => {
    // We use a type assertion here to bridge the gap between the public method's
    // optional 'value' and the internal '_resolve' which strictly expects
    // T | PromiseLike<T>. This reflects how Promises often handle resolve(undefined).
    this._resolve(value as T | PromiseLike<T>);
  };

  /**
   * Rejects the stored promise.
   */
  public reject = (reason?: any): void => {
    this._reject(reason);
  };
}
